import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/categories';

interface ArticleCardProps {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: number;
  viewCount: number;
  tags: string[];
}

export default function ArticleCard({
  title,
  slug,
  excerpt,
  categorySlug,
  coverImage,
  author,
  publishDate,
  readTime,
  viewCount,
  tags,
}: ArticleCardProps) {
  const cat = categoryMap[categorySlug];

  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors group cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
            title={title}
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        {cat && (
          <Link
            to={`/category/${categorySlug}`}
            className="inline-block text-xs font-medium text-primary-500 bg-primary-100/70 px-2 py-0.5 rounded-full mb-2 cursor-pointer whitespace-nowrap"
          >
            {cat.name}
          </Link>
        )}
        <Link to={`/article/${slug}`} className="block">
          <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3">{excerpt}</p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}分钟
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {viewCount >= 10000 ? `${(viewCount / 10000).toFixed(1)}万` : viewCount}
            </span>
            <span className="hidden sm:inline">{publishDate}</span>
          </div>
        </div>
        {tags.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {tags.slice(0, 3).map((tag, i) => (
              <span key={i} className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                #{tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}